<template>
  <div class="activity-box">
    <div class="main">
      <img class="top" src="./images/top.png" alt="" />
      <div class="tabs">
        <div
          class="tabs-item"
          :class="{ active: i === activeTab }"
          v-for="i in 3"
          :key="i"
          @click="checkTab(i)"
        ></div>
      </div>
      <pre-selection
        v-show="activeTab === 1"
        :userInfo="userInfo"
        :honorData="honorData"
      />
      <final-vue
        :userInfo="userInfo"
        :honorData="honorData"
        @getActivityData="getDetail"
        v-show="activeTab === 2"
      ></final-vue>
      <hall-of-honor
        v-show="activeTab === 3"
        :honorData="honorData"
      ></hall-of-honor>
    </div>
  </div>
</template>
<script>
import preSelection from './pre-selection.vue';
import FinalVue from './final.vue';
import HallOfHonor from './hall-of-honor.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  components: {
    'pre-selection': preSelection,
    'final-vue': FinalVue,
    'hall-of-honor': HallOfHonor
  },
  data() {
    return {
      activeTab: 3,
      activityData: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo']),

    honorData() {
      return this.activityData ? this.activityData.appendInfo : {};
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },

  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getDetail();
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    checkTab(index) {
      this.activeTab = index;
      if (index != 3) {
        this.showFinishedDialog();
      }
    },
    // 活動結束提醒
    showFinishedDialog() {
      if (new Date().getTime() > new Date(2024, 0, 27).getTime()) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          // this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        let data = {};

        const result = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'NewYear'
          }
        );
        data = result.data;
        this.activityData = data || {};
        // this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #1c153e;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
  }
  .tabs {
    position: absolute;
    display: flex;
    top: 1072px;
    left: 12px;
    z-index: 2;
    // width: dPx(329);
    .tabs-item {
      flex: none;
      &.active {
        width: 350px;
      }
      width: 295px;
      height: dPx(53);
    }
  }
  .top {
    width: 100%;
  }
}
</style>
